<template>
  <div class="authentication">
    <el-row>
      <el-col>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
        >
          <!-- <el-form-item label="身份证号码" prop="identityCard">
            <el-input v-model="ruleForm.identityCard" placeholder="请输入身份证号码"></el-input>
          </el-form-item> -->
          <el-form-item label="身份证正面" prop="identityCardFront">
            <el-row
              type="flex"
              class="row-bg"
              justify="space-start"
              v-if="ruleForm.identityCardFront"
            >
              <el-col>
                <el-image
                  style="width: 300px; height: 180px"
                  :src="ImageUrl + ruleForm.identityCardFrontText"
                  :preview-src-list="[ruleForm.identityCardFrontText]"
                ></el-image>
              </el-col>
            </el-row>
            <!-- 上传按钮 -->
            <el-row type="flex" class="row-bg" justify="flex-start">
              <!-- <el-col :span="10">
                <div class="front-img">
                  <img src="../../../assets/images/idCard3.png" alt />
                </div>
                <span>样本示例</span>
              </el-col>-->
              <el-col>
                <el-upload
                  :limit="1"
                  :before-upload="uploadFile"
                  :on-change="
                    (file, fileList) => {
                      handleChange(file, fileList, 0);
                    }
                  "
                  action="#"
                  :accept="Accept"
                  :format="Format"
                  :max-size="FileMaxSize"
                  :file-list="fileList"
                  multiple
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-col>
            </el-row>
            <el-popover placement="left-end" width="400" trigger="hover">
              <div class="front-img">
                <img src="../../../../../assets/images/idCard2.png" alt />
              </div>
              <span>身份证正面--样本示例</span>
              <el-button style="margin-top: 20px" slot="reference"
                >样本示例</el-button
              >
            </el-popover>
          </el-form-item>
          <el-form-item label="身份证反面" prop="identityCardBack">
            <el-row
              type="flex"
              class="row-bg"
              justify="space-start"
              v-if="ruleForm.identityCardBack"
            >
              <el-col>
                <el-image
                  style="width: 300px; height: 180px"
                  :src="ruleForm.identityCardBackText"
                  :preview-src-list="[ruleForm.identityCardBackText]"
                ></el-image>
              </el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="flex-start">
              <el-col>
                <el-upload
                  :limit="1"
                  :before-upload="uploadFileBack"
                  :on-change="
                    (file, fileList) => {
                      handleChange(file, fileList, 1);
                    }
                  "
                  action="#"
                  :accept="Accept"
                  :format="Format"
                  :max-size="FileMaxSize"
                  :file-list="fileListBack"
                  multiple
                  list-type="picture-card"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-col>
            </el-row>
            <el-popover
              style="margin-top: 20px"
              placement="left-end"
              width="400"
              trigger="hover"
            >
              <div class="front-img">
                <img src="../../../../../assets/images/idCard3.png" alt />
              </div>
              <span>身份证反面--样本示例</span>
              <el-button style="margin-top: 20px" slot="reference"
                >样本示例</el-button
              >
            </el-popover>
          </el-form-item>

          <el-form-item>
            <div
              class="loginBtn"
              v-if="ruleForm.status === 0 || ruleForm.status === -1"
            >
              <el-button
                class="customBtn"
                style="width: 100%"
                type="primary"
                @click="submitForm('ruleForm')"
                >保存并下一步
              </el-button>
            </div>
            <div class="loginBtn" v-else>
              <el-button
                style="width: 100%"
                @click="$router.back(-1)"
                v-if="againChange"
                >上一步</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import util from "@/utils";
import { mapState } from "vuex";
import { doctorEdit, getDoctorInfo } from "@/api/index.js";
import config from "@/config/config.js";
import { pubSigPutUrl, putFile } from "@/api/upload";
export default {
  data() {
    return {
      loading: false,
      ImageUrl: config.ImageUrl,
      dialogImageUrl: "",
      dialogVisible: false,
      Accept: ".jpg,.jpeg,.png", // 上传文件格式限制
      Format: ["jpg", "jpeg", "png"], // 上传文件格式限制
      FileMaxSize: 1024 * 20, // 最大Kb
      ruleForm: {},
      fileList: [],
      fileListBack: [],
      rules: {
        identityCard: [
          {
            required: true,
            message: "身份证号码不能为空",
            trigger: "blur",
          },
          {
            min: 15,
            max: 18,
            message: "长度在 15 到 18 个数字",
            trigger: "blur",
          },
          {
            // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "证件号码格式有误！",
            trigger: "blur",
          },
        ],
        identityCardFront: [
          {
            required: true,
            message: "身份证正面不能为空",
            trigger: "blur",
          },
        ],
        identityCardBack: [
          {
            required: true,
            message: "身份证正面不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getUserInfo();
    this.$store.commit("updateActive", 2);
  },
  computed: {
    ...mapState(["againChange"]),
  },
  methods: {
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {
          id: util.getStore("user_id"),
        };
        let res = await getDoctorInfo(params);
        if (res.success) this.ruleForm = res.result;
      } catch (error) {}
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    /**
     * 提交保存按钮
     */
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            let res = await doctorEdit(this.ruleForm);
            if (res.success) {
              this.elementTips("success", res.message);
              this.getUserInfo();
              // if(this.againChange){
              if (this.ruleForm.status === 0 || this.ruleForm.status === -1) {
                this.$router.push(
                  "/index/user/auditInformation/qualifications"
                );
              }
            } else {
              this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
              this.elementTips("warning", res.message);
            }
          } else {
            return false;
          }
        } catch (error) {}
      });
    },

    beforeAvatarUpload(file) {
      const isJPG = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt200k = file.size / 1024 < 200;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt200k) {
        this.$message.error("上传头像图片大小不能超过 200kb!");
      }
      return isJPG && isLt200k;
    },
    /**
     * 删除函数
     */
    handleRemove(file, fileList) {
      if (!file.response) {
        return;
      }
      if (
        this.ruleForm.identityCardFront.indexOf(
          file.response.result.relativePath
        ) != -1
      ) {
        this.ruleForm.identityCardFront = "";
        this.ruleForm.identityCardFrontText = "";
      } else if (
        this.ruleForm.identityCardBack.indexOf(
          file.response.result.relativePath
        ) != -1
      ) {
        this.ruleForm.identityCardBackText = "";
        this.ruleForm.identityCardBack = "";
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange(file, filelist, tag) {
      if (file.status === "ready") {
        // 附件变更
        // this.filelist = filelist  //这种方式无法触发手动上传动作
        if (filelist.length > 1) {
          filelist.splice(0, 1);
        }
        if (tag) {
          this.fileListBack = filelist;
        } else {
          this.fileList = filelist;
        }

        this.$forceUpdate();
      }
    },
    // 文件上传之前，判断文件格式。
    async uploadFile(fileObj) {
      const fileExt = fileObj.name.split(".").pop().toLocaleLowerCase();
      if (["jpg", "jpeg", "png"].indexOf(fileExt) !== -1) {
        this.fileUpload(fileObj, 0);
      } else {
        this.$message({
          message:
            "文件类型错误：不是图片类型，请选择后缀为.jpg,.jpeg,.png的图片。",
          type: "error",
        });
        // 删除上传失败的文件
        this.$refs.upload.uploadFiles.splice(
          this.$refs.uploadFile.uploadFiles.indexOf(fileObj.uid),
          1
        );
      }
      return false;
    },
    async uploadFileBack(fileObj) {
      const fileExt = fileObj.name.split(".").pop().toLocaleLowerCase();
      if (["jpg", "jpeg", "png"].indexOf(fileExt) !== -1) {
        this.fileUpload(fileObj, 1);
      } else {
        this.$message({
          message:
            "文件类型错误：不是图片类型，请选择后缀为.jpg,.jpeg,.png的图片。",
          type: "error",
        });
        // 删除上传失败的文件
        this.$refs.upload.uploadFiles.splice(
          this.$refs.uploadFile.uploadFiles.indexOf(fileObj.uid),
          1
        );
      }
      return false;
    },
    // 文件上传至服务器
    async fileUpload(fileObj, tag) {
      this.loading = true;
      const res = await pubSigPutUrl({ fileName: fileObj.name });
      if (res.data.signedUrl) {
        if (tag === 1) {
          this.ruleForm.identityCardBack =
            res.data.serverUrl + res.data.objName;
        } else {
          this.ruleForm.identityCardFront =
            res.data.serverUrl + res.data.objName;
        }
        const fileData = new Blob([fileObj], { type: fileObj.type });
        const resFile = await putFile(
          res.data.signedUrl,
          fileData,
          fileObj.type
        );
        this.loading = false;
        if (resFile.code) {
          this.$message({
            message: "上传文件失败",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "上传文件失败",
          type: "error",
        });
      }
    },
  },
};
</script>
<style scoped>
.status_card {
  top: 90px;
}

.demo-ruleForm {
  position: relative;
  left: -35%;
}

.front-img {
  display: block;
  /* float: right; */
  width: 300px;
  height: 200px;
}

.front-img img {
  width: 100%;
  height: 100%;
}
.authentication {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 3% 0 3% 0;
}

.el-button--primary {
  background-color: #fc701a;
  border-color: #fc701a;
}
</style>
